import { useState } from 'react';
import { Icone } from './ui';
import { REMPLISSAGE_2, TEXTE_DESACTIVE } from '../theme';

/**
 * Vignette du modèle sur les en-têtes de commande. `imageUrl` peut être absent (modèle sans
 * photo côté sipconfection) ou renvoyer une 404/URL S3 expirée : dans les deux cas on retombe sur
 * le même placeholder plutôt que de casser la mise en page.
 */
export default function CommandeImage({ imageUrl, taille = 64 }) {
  const [enErreur, setEnErreur] = useState(false);

  const style = {
    width: taille, height: taille, borderRadius: Math.round(taille * 0.24), flex: 'none',
    background: REMPLISSAGE_2, overflow: 'hidden',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    boxShadow: 'inset 0 0 0 0.5px rgba(0,0,0,0.08)',
  };

  if (!imageUrl || enErreur) {
    return (
      <div style={{ ...style, color: TEXTE_DESACTIVE }}>
        <Icone.Image taille={Math.round(taille * 0.42)} />
      </div>
    );
  }

  return (
    <div style={style}>
      <img
        src={imageUrl}
        alt="Modèle"
        onError={() => setEnErreur(true)}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    </div>
  );
}
